module.exports = __webpack_public_path__ + "img/13_fineStaff_ljf.809c9fdd.png";